import { IssueKind } from 'services/pangolin/types';

export function createKindFilterOptions(existingEntries: IssueKind[]): IssueKind[] {
  const result: IssueKind[] = [];

  Object.keys(IssueKind).forEach((k) => {
    const n = Number(k);
    if (isNaN(n)) return;
    const kind = n as IssueKind;
    const existing = existingEntries.find(entry => entry === kind);
    result.push(existing != null ? existing : kind);
  });

  return result;
}
